import {
  GET_SHORTCUT_APPS_LIST,
  GET_SHORTCUT_APPS_LIST_SUCCESS,
  GET_SHORTCUT_APPS_LIST_ERROR,
  GET_SHORTCUT_APP_DATA,
  GET_SHORTCUT_APP_DATA_SUCCESS,
  GET_SHORTCUT_APP_DATA_ERROR,
  CREATE_SHORTCUT_APP_DATA,
  CREATE_SHORTCUT_APP_DATA_SUCCESS,
  CREATE_SHORTCUT_APP_DATA_ERROR,
  UPDATE_SHORTCUT_APP_DATA,
  UPDATE_SHORTCUT_APP_DATA_SUCCESS,
  UPDATE_SHORTCUT_APP_DATA_ERROR,
  DELETE_SHORTCUT_APP_DATA,
  DELETE_SHORTCUT_APP_DATA_SUCCESS,
  DELETE_SHORTCUT_APP_DATA_ERROR,
} from "./actionType";

// Action for getting shortcut apps list

const initialState = {
  shortcutAppsList: [],
  shortcutAppsListLoading: false,
  shortcutAppData: [],
  shortcutAppDataLoading: false,
  createShortcutAppDataSuccess: [],
  createShortcutAppDataError: [],
  updateShortcutAppDataSuccess: [],
  updateShortcutAppDataError: [],
  deleteShortcutAppDataSuccess: [],
  deleteShortcutAppDataError: [],
};

// Reducer for getting shortcut apps list

const ShortcutApps = (state = initialState, action) => {
  switch (action.type) {
    case GET_SHORTCUT_APPS_LIST:
      return {
        ...state,
        shortcutAppsListLoading: true,
      };
    case GET_SHORTCUT_APPS_LIST_SUCCESS:
      return {
        ...state,
        shortcutAppsList: action.payload,
        shortcutAppsListLoading: false,
      };
    case GET_SHORTCUT_APPS_LIST_ERROR:
      return {
        ...state,
        shortcutAppsListLoading: false,
      };
    case GET_SHORTCUT_APP_DATA:
      return { ...state, shortcutAppDataLoading: true };
    case GET_SHORTCUT_APP_DATA_SUCCESS:
      return {
        ...state,
        shortcutAppData: action.payload,
        shortcutAppDataLoading: false,
      };
    case GET_SHORTCUT_APP_DATA_ERROR:
      return { ...state, shortcutAppDataLoading: false };
    case CREATE_SHORTCUT_APP_DATA:
      return { ...state, shortcutAppDataLoading: true };
    case CREATE_SHORTCUT_APP_DATA_SUCCESS:
      return {
        ...state,
        createShortcutAppDataSuccess: action.payload,
        shortcutAppDataLoading: false,
      };
    case CREATE_SHORTCUT_APP_DATA_ERROR:
      return {
        ...state,
        createShortcutAppDataError: action.payload,
        shortcutAppDataLoading: false,
      };
    case UPDATE_SHORTCUT_APP_DATA:
      return { ...state, shortcutAppDataLoading: true };
    case UPDATE_SHORTCUT_APP_DATA_SUCCESS:
      return {
        ...state,
        updateShortcutAppDataSuccess: action.payload,
        shortcutAppDataLoading: false,
      };
    case UPDATE_SHORTCUT_APP_DATA_ERROR:
      return {
        ...state,
        updateShortcutAppDataError: action.payload,
        shortcutAppDataLoading: false,
      };
    case DELETE_SHORTCUT_APP_DATA:
      return { ...state, shortcutAppDataLoading: true };
    case DELETE_SHORTCUT_APP_DATA_SUCCESS:
      return {
        ...state,
        deleteShortcutAppDataSuccess: action.payload,
        shortcutAppDataLoading: false,
      };
    case DELETE_SHORTCUT_APP_DATA_ERROR:
      return {
        ...state,
        deleteShortcutAppDataError: action.payload,
        shortcutAppDataLoading: false,
      };

    default:
      return state;
  }
};

export default ShortcutApps;
